export default {"src":"/_next/static/media/close_button.071a360e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};